/* eslint-disable quotes */
import isoLanguages from '@cospired/i18n-iso-languages';

// Convert 3-letter language tag to 2-letter language tag
export const normalizeLanguageTag = (tag?: string) =>
  (tag?.length === 3 ? isoLanguages.alpha3TToAlpha2(tag) : tag) ?? tag;

export const formatNameDutch = (
  firstName?: string | null,
  lastName?: string | null,
): string => {
  const firstClean = (firstName ?? '').trim();
  const lastClean = (lastName ?? '').trim();
  if (!firstClean && !lastClean) return '';
  if (!lastClean) return firstClean;

  const lastTokens = lastClean.split(/\s+/);
  const lowerTokens = lastTokens.map(t => t.toLowerCase());

  const prefixes = [
    'van der',
    'van den',
    'van de',
    "van 't",
    'van ’t',
    'van',
    'de',
    'den',
    'der',
    "'t",
    '’t',
    "d'",
    'd’',
    'te',
    'ten',
    'ter',
    'op',
    'aan',
  ];

  let prefixLen = 0;
  for (const p of prefixes) {
    const pTokens = p.split(' ');
    const candidate = lowerTokens.slice(0, pTokens.length).join(' ');
    if (candidate === p) {
      prefixLen = pTokens.length;
      break;
    }
  }

  const tussenvoegsel =
    prefixLen > 0 ? lastTokens.slice(0, prefixLen).join(' ') : '';
  const coreTokens = prefixLen > 0 ? lastTokens.slice(prefixLen) : lastTokens;
  const coreInitial = coreTokens[0]?.[0] ? `${coreTokens[0][0]}.` : '';
  const parts = [firstClean, tussenvoegsel, coreInitial].filter(Boolean);
  return parts.join(' ').replace(/\s+/g, ' ').trim();
};
